import styled from 'styled-components'
import { Tab, Tabs } from '@material-ui/core'

export const Wrapper = styled.div`
  width: 100%;
  padding: 2px;

  .MuiTabs-scrollButtons {
    svg {
      opacity: 0.5;
    }
  }
`

export const StyledScrollableTabs = styled(Tabs)({
  '&.MuiTabs-root': {
    borderRadius: '6px',
    overflow: 'none',
    backgroundColor: '#FFF !important'
  },

  '& .MuiTabs-indicator': {
    backgroundColor: '#FFF',
    border: '1px solid #026860FF'
  },

  '& .MuiTabs-scrollButtons.Mui-disabled': {
    opacity: 0.3,
    backgroundColor: '#C7C7C7'
  },

  '& .MuiTabs-scrollButtons': {
    backgroundColor: '#F0F6EF',
    width: '20px',
    transition: '400ms'
  }
})

export const StyledTab = styled(Tab)({
  '& .MuiTab-wrapper': {
    fontWeight: 500,
    color: '#9B9B9B',
    textTransform: 'capitalize',
    fontFamily:
      "Poppins, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif"
  },
  '&.MuiTab-root': {
    borderRadius: '6px'
  },
  '&.Mui-selected': {
    '& .MuiTab-wrapper': {
      fontWeight: 600,
      color: '#026860FF'
    }
  }
})

export const ActiveTabPanel = styled.div``
